import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '.';
import { InputsReducerTypes } from '../types';
import phoneNumberFormatter from '../functions/phoneNumberFormatter';

const initialState: InputsReducerTypes = {
  firstName: '',
  lastName: '',
  zipCode: '',
  email: '',
  preferredContactMethod: 'email',
  preferredContactTime: 'NO_PREFERENCE',
  phoneNumber: '',
  topicOfInterest: '',
  ccpa: false,
  universalConsent: false,
  dealerConsent: false,
  tcpaConsent: false,
  oemConsent: false,
  tradeInVehicleMake: '',
  tradeInVehicleModel: '',
  tradeInVehicleYear: '',
  tradeInVehicleMileage: '',
  tradeInVehicleTrimLine: '',
  tradeInVehicleVin: '',
  modelFamilyOfInterest: '',
  modelLineOfInterest: '',
};

const inputsSlice = createSlice({
  name: 'inputs',
  initialState,
  reducers: {
    setUserInputs: (state, action) => {
      const { inputName, inputValue } = action.payload;
      if (inputName === 'phoneNumber' && state.phoneNumber?.length < inputValue?.length) {
        return { ...state, phoneNumber: phoneNumberFormatter(inputValue) };
      }
      return { ...state, [inputName]: inputValue };
    },
    cleanInputs: (state) => {
      return {
        ...state,
        firstName: '',
        lastName: '',
        zipCode: '',
        email: '',
        phoneNumber: '',
        topicOfInterest: '',
      };
    },
  },
});

export const selectInputs = (state: RootState) => state.userInputs;

export const { setUserInputs, cleanInputs } = inputsSlice.actions;

export default inputsSlice.reducer;
